import React, { useEffect } from "react";

import useTranslations from "containers/hooks/useLanguageHook";
import { useContentSize } from "containers/hooks/useWindowSize";
import PieChart, { SubCategories } from "containers/Visuals/PieChart";
import { setSidebarFilter } from "@store/filters/actions";
import { FilterType } from "@store/filters/types";
import { useAppDispatch, useAppSelector } from "index";
import { setCurrentVisualization } from "@store/options/actions";
import { VisTypes } from "@store/options/types";
import { VisPageWrapper } from "@pages/VisPageWrapper";
import { ApplicationState } from "@store/index";
import { Grid } from "@mui/material";
import { calculateGridItemSize } from "@utils/format";
import { GridSize } from "@mui/material/Grid";
import MultipleViewTitleGrid from "../Components/MultipleViewTitleGrid";
import { getProvider } from "../../fileParsing/definitions";
import { switchActive } from "@store/data/actions";
import DragDropContextPieChart from "../Visuals/PieChart/DragDropContext";
import { useTheme } from "@mui/material/styles";
const PieChartImage = new URL("../../../public/piechart.png", import.meta.url).href;

function PiechartPage() {
  const { width, height } = useContentSize();
  const { t } = useTranslations();
  const dispatch = useAppDispatch();

  const theme = useTheme();

  useEffect(() => {
    dispatch(setSidebarFilter([FilterType.categories]));
    dispatch(setCurrentVisualization(VisTypes.Piechart));
  }, []);

  const options = useAppSelector((state: ApplicationState) => state.options.options);
  const providerItems = useAppSelector((state: ApplicationState) => state.data.exports);

  const [subCategories, setSubCategories] = React.useState<SubCategories | undefined>(undefined);

  const activeExports = providerItems.filter((d) => d.active);

  const categorySectionHeight = 350;
  const pieChartHeight = (height - categorySectionHeight) * 0.95 - theme.sidebar.footerHeight * 2;

  return (
    <VisPageWrapper
      title={t.Vis.PieChart}
      help={{
        title: t.LandingPage.PieChartTitle,
        description: t.LandingPage.PieChartText,
        image: PieChartImage,
      }}
    >
      {options.MultipleViews.value && activeExports.length > 1 ? (
        <Grid container spacing={1}>
          {activeExports.map((d, _, list) => (
            <Grid item xs={calculateGridItemSize(list.length) as GridSize} key={d.id}>
              <MultipleViewTitleGrid
                fileName={d.fileProperties.fileName}
                providerName={d.providerId === "wrangled" ? t.DataPage.UnknownProvider : getProvider(d.providerId).name}
                handleHide={() => dispatch(switchActive(d.id))}
              />
              <PieChart
                exportId={d.id}
                settings={{
                  width,
                  height: height / 2 - 84,
                }}
                subCategories={subCategories ?? {}}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <PieChart
          settings={{
            width,
            height: pieChartHeight,
          }}
          subCategories={subCategories ?? {}}
        />
      )}
      <DragDropContextPieChart
        settings={{
          height: categorySectionHeight,
        }}
        onSubcategoryChange={(newSubs) => setSubCategories(newSubs)}
      />
    </VisPageWrapper>
  );
}

export { PiechartPage };
